import { getBooleanValue } from '../../../shared/api/session/getBooleanValue.js';
import { prepareStep } from '../view/prepareStep.js';
import { showErrorAlert } from '../view/showErrorAlert.js';
import { showFormAlert } from '../view/showFormAlert.js';

const SECCODE_REGEXP = /^\d{1,9}$/;

/* EXAMPLE stepData
  {
    "result": "1", // Envío sms OK / KO
  }
*/
export default {
  events: {
    visible: (eWizard, stepData, _params, enrollform) => {
      // init:
      stepData.type = 2;

      // Acción: smsRetry
      const eButton = eWizard.querySelector('#retry');
      if (eButton) {
        const smsRetry = () => {
          eButton.state = 'loading';

          prepareStep(enrollform.token, enrollform.user, enrollform.stepNum)
            .then((responseData) => {
              stepData.result = responseData.result; // Lo mantenemos actualizado
              eButton.state = getBooleanValue(responseData.result) ? 'resolved' : 'rejected';
            })
            .catch(() => {
              showErrorAlert();
              eButton.state = 'rejected';
            });
        };
        eButton.addEventListener('click', smsRetry);
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const code = eWizard.querySelector('#code')?.value;
      if (!code) {
        showFormAlert();
      } else if (!SECCODE_REGEXP.test(code)) {
        showFormAlert('enrollment.sms_verify.invalid_otp');
      } else {
        stepData.code = code;
        resolve(stepData);
        return; // OK
      }

      reject(); // KO
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.sms_verify.title')}">
    <ewc-alert type="flat" label="${edicom.locale.translate('enrollment.sms_verify.text')}">
      <div style="white-space:normal;">${edicom.locale.translate('enrollment.sms_verify.info')}</div>
    </ewc-alert>
    <br/>
    <ewc-string id="code" label="${edicom.locale.translate('enrollment.sms_verify.code')}" maxlength="9" pattern="${SECCODE_REGEXP}" required>
      <div slot="end">
        <ewc-button id="retry" icon="rotate" title="${edicom.locale.translate('enrollment.sms_verify.retry')}"></ewc-button>
      </div>    
    </ewc-string>
  </template>`,
};
